(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/andra-chansen-banners/views/info-banner.js') >= 0) return;  svs.modules.push('/components/numbergames/andra-chansen-banners/views/info-banner.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.numbergames=_svs.numbergames||{};
_svs.numbergames.andra_chansen_banners=_svs.numbergames.andra_chansen_banners||{};
_svs.numbergames.andra_chansen_banners.templates=_svs.numbergames.andra_chansen_banners.templates||{};
svs.numbergames.andra_chansen_banners.templates.info_banner = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <p class=\"andra-chansen-banner-message f-550\">\n    Varje spelad Lottorad med Joker ger "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isSyndicate") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data,"loc":{"start":{"line":3,"column":40},"end":{"line":3,"column":79}}})) != null ? stack1 : "")
    + " 1 chans att vinna på Andra Chansen den "
    + container.escapeExpression((lookupProperty(helpers,"formatTime")||(depth0 && lookupProperty(depth0,"formatTime"))||container.hooks.helperMissing).call(alias1,"d MMMM",(depth0 != null ? lookupProperty(depth0,"endDate") : depth0),{"name":"formatTime","hash":{},"data":data,"loc":{"start":{"line":3,"column":119},"end":{"line":3,"column":150}}}))
    + ".\n  </p>\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "er";
},"4":function(container,depth0,helpers,partials,data) {
    return "dig";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"numbergames")||(depth0 && lookupProperty(depth0,"numbergames"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"andra-chansen_banners/banner",depth0,{"name":"numbergames","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":5,"column":16}}})) != null ? stack1 : "");
},"useData":true});
Handlebars.partials['components-numbergames-andra_chansen_banners-info_banner'] = svs.numbergames.andra_chansen_banners.templates.info_banner;
})(svs, Handlebars);


 })(window);